import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { CHART_COLOR_PALETTE } from '../colors';
import type { BuildChartContext } from '../catalog/types';
import { CHART_TOKENS } from '../tokens';
import { useProjectTimezone } from 'store/project';

export function useBuildChartContext(
  variant: BuildChartContext['variant'] = 'dashboard'
): BuildChartContext {
  const intl = useIntl();
  const timezone = useProjectTimezone();

  return useMemo(
    (): BuildChartContext => ({
      intl,
      variant,
      locale: intl.locale,
      timezone,
      tokens: CHART_TOKENS,
      colors: CHART_COLOR_PALETTE,
    }),
    [intl, variant, timezone]
  );
}
